import { ChangeDetectorRef, Input } from '@angular/core';
import { SimpleChange } from '@angular/core';
import { EventEmitter, Output, ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { ControlUser } from 'src/app/model/controlUser';
import { DevicePilomat } from 'src/app/model/devicePilomat';
import { DeviceService } from 'src/app/service/device.service';
import { Log } from 'src/app/util/log';

@Component({
  selector: 'app-owner-devices-list',
  templateUrl: './owner-devices-list.component.html',
  styleUrls: ['./owner-devices-list.component.css']
})
export class OwnerDevicesListComponent implements OnInit {

  @Input() reload: Object;
  @Input() owner: ControlUser;
  @ViewChild('ownerdeviceslisttable', { static: true }) table;
  @ViewChild('ownerdeviceslistloader', { static: true }) loader;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() selected = new EventEmitter<DevicePilomat>();
  selectedDevice: DevicePilomat;
  selectedRow: number;

  dataSource: DevicesSource;

  displayedColumns: string[] = ['name', 'serial', 'version' ];

  constructor(private deviceService: DeviceService, private cdRef:ChangeDetectorRef) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.loader.showLoading();
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.owner) {
    
      const ownerChange: SimpleChange = changes.owner;

      this.getOwnerDevices(ownerChange.currentValue.uid);
    
    }
    else if (changes.reload) {

      Log.debug("must reload ");

      this.getOwnerDevices(this.owner.uid);
    }
  }

  public reloadData(): void {

  }

  getOwnerDevices(uid: string) {

    Log.debug("getOwnerDevices: " + uid);

    this.loader.showLoading();

    this.dataSource = new DevicesSource(uid, this.deviceService);

      this.table.dataSource = this.dataSource;

      this.dataSource.devicesData.subscribe(data => {

        Log.debug("devicesData: " + JSON.stringify(data));

        setTimeout(() => {

          this.cdRef.detectChanges();
        });
        
      }, error => {

        this.loader.hideLoading();
        this.loader.showError();
      });

      setTimeout(() => {
        
        this.sort.sortChange.subscribe(v => Log.debug(v) )

        this.dataSource.isLoading.subscribe(isLoading => {

          if(!isLoading) {
            this.loader.hideLoading();
          }
        });
      });
  }

  onRowClicked(row) {

    Log.debug('clicked device with id ' + row.id);

    this.selectedRow = row.id;

    this.selected.emit(row);
    this.selectedDevice = row;
    
    this.cdRef.detectChanges();
  }
}

export class DevicesSource extends MatTableDataSource<DevicePilomat> {

  isLoading = new BehaviorSubject(false);
  devicesData = new BehaviorSubject<DevicePilomat[]>([]);

  constructor(private uid: string, private deviceService: DeviceService) {
    super();

    // this.filterPredicate = function (data: DevicePilomat, filter: string): boolean {
    //   Log.debug("filter: " + filter);
    //   return false;
    // }
  }

  loadData() {

    this.isLoading.next(true);

    const obs = this.deviceService.getOwnerDevices(this.uid);
    obs.subscribe(data => {

      this.isLoading.next(false);
      this.devicesData.next(data);
    });
  }

  connect(): BehaviorSubject<DevicePilomat[]> {

    this.loadData();
    return this.devicesData;
  }

  disconnect() {
  }
}
